function RedErrorIcon(props: {}) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.0277 16.223L14.6457 4.87804C14.1007 3.90804 13.1107 3.33008 11.9987 3.33008C10.8866 3.33008 9.89668 3.90906 9.35168 4.87804L2.96968 16.223C2.43468 17.1741 2.44468 18.305 2.99468 19.246C3.54468 20.1871 4.5257 20.75 5.61668 20.75H18.3807C19.4717 20.75 20.4517 20.188 21.0027 19.246C21.5537 18.304 21.5627 17.174 21.0277 16.223ZM19.7077 18.49C19.4287 18.9671 18.9327 19.2511 18.3806 19.2511H5.61664C5.0646 19.2511 4.56868 18.9671 4.2896 18.49C4.01062 18.0121 4.00562 17.4411 4.27663 16.959L10.6586 5.61402C10.9346 5.123 11.4357 4.83004 11.9986 4.83004C12.5616 4.83004 13.0626 5.123 13.3386 5.61402L19.7206 16.959C19.9916 17.4411 19.9867 18.013 19.7077 18.49Z"
				fill="#8A1C23"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.4619 4.8421C12.8122 3.7193 11.1878 3.7193 10.5381 4.84211L3.22867 17.4737C2.57895 18.5965 3.3911 20 4.69056 20H19.3094C20.6089 20 21.4211 18.5965 20.7713 17.4737L13.4619 4.8421ZM11.249 9.00098V13.001C11.249 13.415 11.585 13.751 11.999 13.751C12.413 13.751 12.749 13.415 12.749 13.001V9.00098C12.749 8.587 12.413 8.25098 11.999 8.25098C11.585 8.25098 11.249 8.587 11.249 9.00098ZM11.999 17.001C12.5511 17.001 12.999 16.553 12.999 16.001C12.999 15.4489 12.5511 15.001 11.999 15.001C11.447 15.001 10.999 15.4489 10.999 16.001C10.999 16.553 11.447 17.001 11.999 17.001Z"
				fill="#8A1C23"
			/>
		</svg>
	);
}

function RedTrashIcon(props: {}) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 7C5 6.44772 5.44772 6 6 6H17C17.5523 6 18 6.44772 18 7V20C18 20.5523 17.5523 21 17 21H7C5.89543 21 5 20.1046 5 19V7Z"
				fill="#8A1C23"
			/>
			<path
				d="M5.37659 5.69238H18.0082V18.2924C18.0082 19.1325 18.0082 19.5525 17.8705 19.8734C17.7494 20.1556 17.5562 20.3851 17.3185 20.5289C17.0483 20.6924 16.6946 20.6924 15.9871 20.6924H7.39765C6.69021 20.6924 6.33649 20.6924 6.06629 20.5289C5.82861 20.3851 5.63537 20.1556 5.51427 19.8734C5.37659 19.5525 5.37659 19.1325 5.37659 18.2924V5.69238Z"
				fill="#8A1C23"
			/>
			<path
				d="M3.69238 5.19238C3.41624 5.19238 3.19238 5.41624 3.19238 5.69238C3.19238 5.96853 3.41624 6.19238 3.69238 6.19238V5.19238ZM19.6924 6.19238C19.9685 6.19238 20.1924 5.96853 20.1924 5.69238C20.1924 5.41624 19.9685 5.19238 19.6924 5.19238V6.19238ZM5.37659 5.69238V5.19238H4.87659V5.69238H5.37659ZM18.0082 5.69238H18.5082V5.19238H18.0082V5.69238ZM6.06629 20.5289L5.80745 20.9567L6.06629 20.5289ZM5.51427 19.8734L5.05478 20.0705L5.51427 19.8734ZM17.8705 19.8734L18.33 20.0705L17.8705 19.8734ZM17.3185 20.5289L17.5773 20.9567L17.3185 20.5289ZM3.69238 6.19238H19.6924V5.19238H3.69238V6.19238ZM5.37659 6.19238H18.0082V5.19238H5.37659V6.19238ZM17.5082 5.69238V18.2924H18.5082V5.69238H17.5082ZM15.9871 20.1924H7.39765V21.1924H15.9871V20.1924ZM5.87659 18.2924V5.69238H4.87659V18.2924H5.87659ZM7.39765 20.1924C7.03415 20.1924 6.7972 20.1918 6.61629 20.1743C6.44431 20.1576 6.37118 20.129 6.32513 20.1011L5.80745 20.9567C6.03161 21.0923 6.27044 21.1454 6.51972 21.1696C6.76008 21.1929 7.0537 21.1924 7.39765 21.1924V20.1924ZM4.87659 18.2924C4.87659 18.7055 4.87632 19.0406 4.89498 19.3119C4.91391 19.5869 4.95411 19.8359 5.05478 20.0705L5.97376 19.6762C5.93675 19.59 5.90812 19.4685 5.89262 19.2433C5.87687 19.0143 5.87659 18.7194 5.87659 18.2924H4.87659ZM6.32513 20.1011C6.18617 20.017 6.05825 19.8731 5.97376 19.6762L5.05478 20.0705C5.21249 20.4381 5.47105 20.7531 5.80745 20.9567L6.32513 20.1011ZM17.5082 18.2924C17.5082 18.7194 17.5079 19.0143 17.4921 19.2433C17.4766 19.4685 17.448 19.59 17.411 19.6762L18.33 20.0705C18.4307 19.8359 18.4709 19.5869 18.4898 19.3119C18.5084 19.0406 18.5082 18.7055 18.5082 18.2924H17.5082ZM15.9871 21.1924C16.3311 21.1924 16.6247 21.1929 16.865 21.1696C17.1143 21.1454 17.3532 21.0923 17.5773 20.9567L17.0596 20.1011C17.0136 20.129 16.9405 20.1576 16.7685 20.1743C16.5876 20.1918 16.3506 20.1924 15.9871 20.1924V21.1924ZM17.411 19.6762C17.3265 19.8731 17.1986 20.017 17.0596 20.1011L17.5773 20.9567C17.9137 20.7531 18.1723 20.4381 18.33 20.0705L17.411 19.6762Z"
				fill="#8A1C23"
			/>
			<path
				d="M9.69238 8.69238V17.6924"
				stroke="#F8C0C4"
				strokeLinecap="round"
			/>
			<path
				d="M13.6924 8.69238V17.6924"
				stroke="#F8C0C4"
				strokeLinecap="round"
			/>
			<path
				d="M9.69238 3.69238H13.6924"
				stroke="#8A1C23"
				strokeLinecap="round"
			/>
		</svg>
	);
}

function RedCrossIcon(props: {}) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
				fill="#E7424D"
			/>
			<rect width="14" height="14" transform="translate(3 3)" fill="#E7424D" />
			<path
				d="M13.5 6.5L6.5 13.5"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.5 6.5L13.5 13.5"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export { RedErrorIcon, RedTrashIcon, RedCrossIcon };
